import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOffer as deleteOfferApi } from "../../../../services/dashboard/apiOffers";
import toast from "react-hot-toast";

export function useDeleteOffer() {
  const queryClient = useQueryClient();

  const {
    mutate: deleteOffer,
    isLoading: isDeleting,
    error,
  } = useMutation({
    mutationFn: deleteOfferApi,
    onSuccess: () => {
      toast.success("تم حذف العرض بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["offers"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { deleteOffer, isDeleting, error };
}
